
import { Button } from "@/components/ui/button";
import RatingChart from "./RatingChart";

const Stats = () => {
  return null;
};

export default Stats;
